import { render } from "./WalletDataList.vue?vue&type=template&id=4f1ce0c5&scoped=true"
import script from "./WalletDataList.vue?vue&type=script&lang=js"
export * from "./WalletDataList.vue?vue&type=script&lang=js"

import "./WalletDataList.vue?vue&type=style&index=0&id=4f1ce0c5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4f1ce0c5"

export default script